import { Component, OnInit, ViewChild, ElementRef, Input, SimpleChanges, OnChanges } from '@angular/core'
import ReactDOM from 'react-dom'
import React, { useEffect, useState } from 'react'
import { TextField, Button } from '@dfds-ui/react-components'
import styled from '@emotion/styled'
import { FormControl } from '@angular/forms'
import { CodeStatus } from '../travel.interfaces'
import { ResourceService } from 'app/shared/resources/resource.service'

@Component({
    selector: 'sbw-travel-code',
    template: '<div #react></div>'
})
export class TravelCodeComponent implements OnInit, OnChanges {

    constructor(
        private resourceService: ResourceService
    ) { }

    @Input() heading: string
    @Input() buttonText: string
    @Input() control: FormControl
    @Input() codeStatus: CodeStatus = 'CodeNotSpecified';
    setAssistiveTextHook = () => { }

    @ViewChild('react', { static: true }) react: ElementRef

    ngOnInit() {
        this.control.valueChanges.subscribe(() => {
            this.render()
        })
    }

    render() {
        interface Props {
            offerCode: string
        }

        const StyledButton = styled(Button)`
            width: 100%;
            margin-top: 6px;
        `

        const StyledTextField = styled(TextField)`
            input {
                text-transform: uppercase;
                border-radius: 0px;
            }

            @media screen and (max-width: 640px) {
                padding-right: 0;
            }
        `

        const StyledH1 = styled.div`
            h1 {
                margin-top: 1rem;
            }
        `

        const TravelOfferCode = (props: Props) => {
            const [offercode, setOffercode] = useState(props.offerCode)
            const [assistiveText, setAssistiveText] = useState("")
            const [errorText, setErrorText] = useState("")

            useEffect(() => {
                setAssistiveTextHook()
            }, []);

            const updateOfferCode = (inputValue) => {
                setOffercode(inputValue.target.value)
            }

            const verifyCode = () => {
                this.control.setValue(offercode)
            }

            const setAssistiveTextHook = (): void => {
                this.resourceService.get(this.getResourceKey(), false).subscribe(s => {
                    if (this.codeStatus === this.IS_VALID_OFFERCODE || this.codeStatus === this.IS_VALID_PRODUCTCODE) {
                        setAssistiveText(s)
                    }
                    else {
                        setAssistiveText('')
                    }
                    setErrorText(this.codeStatus === this.IS_INVALID_OFFERCODE || this.codeStatus === this.ROUTES_AND_PRODUCT_DOES_NOT_MATCH ? s : '')
                })
            }
            this.setAssistiveTextHook = setAssistiveTextHook

            return (
                <div>
                    <StyledH1><h1>{this.heading}</h1></StyledH1>
                    <div className="row">
                        <div className="collapse inline-right secondary-action-form">
                            <div className="column small-12 medium-5">
                                <StyledTextField
                                    name="suppliedCode"
                                    assistiveText={assistiveText}
                                    defaultValue={props.offerCode}
                                    errorMessage={errorText}
                                    onChange={updateOfferCode}
                                />
                            </div>
                            <div className="column small-12 medium-3 label end">
                                <StyledButton id={"sbw_update_product"} variation="secondary" onClick={verifyCode}>{this.buttonText}</StyledButton>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        ReactDOM.render(<TravelOfferCode offerCode={this.control && this.control.value} />, this.react.nativeElement)
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.setAssistiveTextHook()
        this.render()
    }

    getResourceKey = (): string => {
        switch (this.codeStatus) {
            case this.IS_VALID_OFFERCODE:
                return 'OFFER_CODE_CORRECT'
            case this.IS_INVALID_OFFERCODE:
                return 'VALIDATION_OFFER_CODE_WRONG'
            case this.IS_VALID_PRODUCTCODE:
                return 'OFFER_CODE_CORRECT'
            case this.ROUTES_AND_PRODUCT_DOES_NOT_MATCH:
                return 'VALIDATION_PRODUCT_DOES_NOT_CONTAIN_ROUTE'
            default:
                return '';
        }
    }

    private IS_VALID_OFFERCODE: string = 'IsValidOfferCode'
    private IS_VALID_PRODUCTCODE: string = 'IsValidProductCode'
    private IS_INVALID_OFFERCODE: string = 'IsInvalidOfferCode'
    private ROUTES_AND_PRODUCT_DOES_NOT_MATCH: string = 'RoutesAndProductDoesNotMatch'
}
